import React from "react";
import ServiceHeader from "../../component/ServiceHeader";
import ContactUs from "../../component/contactus";
import "../../views/PageContent.css";
// import Myimage from "../../assets/AI images/Autoscribe.jpg ";
import LLMVideo from "../../assets/videos/LlmInsight.mp4"; 

const LLMInsight = () => {
  return (
    <div className="wrapper">
      {<ServiceHeader title="LLM INSIGHT" />}
      <div className="row mp">
        <div className="col-sm-3 mpc">
          <ContactUs />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-8">
          <div className="imgg">
            {/* <img src={Myimage} alt="LLM Insight"></img> */}
          </div>

          {/* VIDEO SECTION */}
          <div className="video-container">
            {/* <h3>Watch LLM Insight in Action</h3> */}
            <video width="100%" height="auto"  controls autoPlay muted loop>
              <source src={LLMVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="row middle">
            <h2>LLM Insight</h2>
            <p>
              LLM Insight is an advanced governance and cost management platform 
              for Large Language Models (LLMs). It streamlines tracking, cost allocation, 
              and real-time monitoring while ensuring secure access control through the **SSTAI Framework**.
            </p>

            <h4>Challenges in LLM Management</h4>
            <p>
              Managing LLM usage effectively poses several challenges:
              <ul>
                <li>Limited insights into LLM deployments across projects.</li>
                <li>Complex cost tracking and attribution.</li>
                <li>Absence of real-time monitoring and budget controls.</li>
                <li>Inconsistent access management and permission handling.</li>
              </ul>
            </p>

            <h4>Our Solution</h4>
            <p>
              LLM Insight provides a **centralized** and **efficient** approach to overcome these 
              challenges. Key features include:
              <ul>
                <li>Real-time LLM usage tracking and cost monitoring.</li>
                <li>Automated cost attribution for teams and projects.</li>
                <li>Customizable budget limits to prevent overspending.</li>
                <li>Unified chat interface for seamless interactions with multiple LLMs.</li>
                <li>Secure access control integrated with Active Directory.</li>
              </ul>
            </p>

            <h4>Key Benefits</h4>
            <p>
              <ul>
                <li><strong>Transparency:</strong> Centralized logging for clear insights.</li>
                <li><strong>Cost Efficiency:</strong> Monitors and optimizes LLM-related expenses.</li>
                <li><strong>Scalability:</strong> Flexible architecture with modular microservices.</li>
                <li><strong>Security:</strong> Controlled access and usage monitoring.</li>
                <li><strong>Productivity:</strong> Single chat interface reduces complexity.</li>
              </ul>
            </p>

            <h4>Architecture Overview</h4>
            <p>
              The platform follows a **containerized microservices approach**, ensuring efficiency, 
              security, and scalability. LLM Insight seamlessly integrates with existing IT infrastructure 
              to provide a robust governance mechanism for enterprises.
            </p>

            <h4>Explore LLM Insight</h4>
            <p>
              Discover the full potential of LLM Insight with our live demo:  
              <br />
              🔗 <a href="https://dev.llminsight.ai" target="_blank" rel="noopener noreferrer">LLM Insight Demo</a>
            </p>

          
          </div>
        </div>
      </div>
    </div>
  );
};

export default LLMInsight;
